import React from 'react';
import { Trans } from 'react-i18next';
import { Space } from 'common/components/antd/Space/Space';
import { EReconciliationStatus } from 'domains/reconciliation/types/reconciliation.types';

export const tabItems = [
  {
    key: EReconciliationStatus.Draft,
    label: (
      <Space direction="horizontal">
        <Trans i18nKey="reconciliation.statistic.status.draft" />
        {/* <TabBadge color="#8C8C8C" count={2} /> */}
      </Space>
    ),
    children: null,
  },
  {
    key: EReconciliationStatus.AwaitingPayment,
    label: (
      <Space direction="horizontal">
        <Trans i18nKey="reconciliation.statistic.status.awaitingPayment" />
        {/* <TabBadge color="#8C8C8C" count={2} /> */}
      </Space>
    ),
    children: null,
  },
  {
    key: EReconciliationStatus.AwaitingConfirmation,
    label: <Trans i18nKey="reconciliation.statistic.status.awaitingConfirmation" />,
    children: null,
  },
  {
    key: EReconciliationStatus.Calculated,
    label: (
      <Space direction="horizontal">
        <Trans i18nKey="reconciliation.statistic.status.calculated" />
        {/* <TabBadge color="cyan" count={2} /> */}
      </Space>
    ),
    children: null,
    className: 'tab-cyan',
  },
  {
    key: EReconciliationStatus.Confirmed,
    label: (
      <Space direction="horizontal">
        <Trans i18nKey="reconciliation.statistic.status.confirmed" />
        {/* <TabBadge color="green" count={2} /> */}
      </Space>
    ),
    children: null,
    className: 'tab-green',
  },
  {
    key: EReconciliationStatus.Overdue,
    label: (
      <Space direction="horizontal">
        <Trans i18nKey="reconciliation.statistic.status.overdue" />
      </Space>
    ),
    children: null,
    className: 'tab-red',
  },
  {
    key: EReconciliationStatus.Appeal,
    label: (
      <Space direction="horizontal">
        <Trans i18nKey="reconciliation.statistic.status.appeal" />
      </Space>
    ),
    children: null,
    className: 'tab-red',
  },
];
